import AppFooter from "../AppFooter";

function CustomerFooter() {
    return <AppFooter sticky />;
}

export default CustomerFooter;
